import styled from "styled-components";

export const StyledAppsPriceFilterContent = styled.div`
    width: 260px;
`;
